import { useEstiloDeImpresion } from '../experiencia/estiloDeImpresion';
import { Printer } from 'lucide-react';
import CodigoQR from '../ui/CodigoQR';

/* =====================================================================
   La hoja de impresión del gafete · TC-28
   =====================================================================
   El cartón se dibujaba dentro del modal y salía con el modal. Esto es
   una hoja: tamaño de credencial (85.6 × 54 mm, ISO/IEC 7810 ID-1),
   márgenes, y solo el cartón visible al imprimir. Mismo patrón que el
   ticket de venta: el estilo de impresión se inyecta mientras el
   componente vive y se retira al desmontarlo. Tinta negra sobre papel
   blanco la impone `CodigoQR`.
   ===================================================================== */
const ANCHO = '85.6mm';
const ALTO = '54mm';

function useEstiloDeHoja() {
  // HOJA CONSTRUIDA, NO <style> (19 sep 2026). La CSP de producción manda
  // `style-src-elem 'self'` y tiraba el <style> inyectado sin más aviso
  // que la consola: al pulsar «Imprimir gafete» salía el modal entero, no
  // el cartón. Lo midió la auditoría de botones. Ver
  // experiencia/estiloDeImpresion.js; el CSS es el mismo de antes.
  useEstiloDeImpresion(`
      @media print {
        @page { size: ${ANCHO} ${ALTO}; margin: 0; }
        body * { visibility: hidden; }
        #hoja-de-gafete, #hoja-de-gafete * { visibility: visible; }
        #hoja-de-gafete {
          position: fixed; left: 0; top: 0; width: ${ANCHO}; height: ${ALTO};
          margin: 0; padding: 4mm; box-sizing: border-box; background: #fff; color: #000;
          display: flex; align-items: center; gap: 4mm; border: 0;
        }
        .sin-imprimir { display: none !important; }
      }
    `);
}

export default function HojaDeGafete({ persona, token, vence, empresa }) {
  useEstiloDeHoja();
  return (
    <div className="space-y-2">
      <div id="hoja-de-gafete" className="flex items-center gap-3 rounded-lg border-2 border-gray-900 bg-white p-3"
           style={{ width: ANCHO, height: ALTO, boxSizing: 'border-box' }}>
        <CodigoQR valor={token} tamano={120} etiqueta={`Gafete de ${persona}`} />
        <div className="min-w-0" style={{ color: '#000' }}>
          <p className="text-[9px] uppercase tracking-wider" style={{ color: '#555' }}>{empresa ? `${empresa} · ` : ''}Gafete de operador</p>
          <p className="break-words text-sm font-bold leading-tight">{persona}</p>
          <p className="mt-1 text-[10px]" style={{ color: '#555' }}>Vence {String(vence || '').slice(0, 10)}</p>
        </div>
      </div>
      <button type="button" onClick={() => window.print()}
              className="sin-imprimir inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700">
        <Printer className="h-4 w-4" aria-hidden="true" /> Imprimir en tamaño credencial
      </button>
      <p className="sin-imprimir text-xs text-gray-500">Sale una credencial de 85.6 × 54 mm por hoja, sin márgenes. Si tu impresora pide tamaño, elige «tarjeta» o «ID-1».</p>
    </div>
  );
}
